
import { Quest, QuestCategory } from '../../../types';

export const CLIMBING_CATALYST_QUESTS: Quest[] = [
  {
    id: 2100,
    category: QuestCategory.SkillBuilder,
    title: 'Grip Guardian',
    questlineId: 'climbing-catalyst',
    isQuestlineStart: true,
    description: 'Climbing is all about grip. Let\'s start building your hand and forearm strength.',
    details: 'Find a safe pull-up bar or sturdy tree branch. Your mission is to hang for as long as you can. Rest, then repeat two more times. Write down your best time in your training log (your notebook)!'
  },
  {
    id: 2101,
    category: QuestCategory.SkillBuilder,
    title: 'Core Power',
    questlineId: 'climbing-catalyst',
    prerequisiteQuestId: 2100,
    description: 'A strong core helps you stay on the wall. Time to train your abs and back.',
    details: 'The plank is a perfect exercise for core strength. Get into a push-up position but rest on your forearms. Keep your body in a straight line. Hold it for 30 seconds. Rest, then repeat twice more.'
  },
  {
    id: 2102,
    category: QuestCategory.SkillBuilder,
    title: 'Flexible Fingers',
    questlineId: 'climbing-catalyst',
    prerequisiteQuestId: 2101,
    description: 'Strong fingers need to be flexible too. Let\'s do some simple hand stretches.',
    details: 'Gently stretch your fingers and wrists to keep them healthy for climbing. Hold your arm out, palm up, and gently pull your fingers back with your other hand. Hold for 15 seconds. Repeat on both hands.',
    youtubeId: 'G12g-UaW4so'
  },
  {
    id: 2103,
    category: QuestCategory.SkillBuilder,
    title: 'Balance Master',
    questlineId: 'climbing-catalyst',
    prerequisiteQuestId: 2102,
    description: 'Climbing often means putting all your weight on one foot. Let\'s practice your balance.',
    details: 'Stand on one leg for as long as you can. To make it harder, try closing your eyes for a few seconds. Switch legs. This builds the stability you need for tricky moves.'
  },
  {
    id: 2104,
    category: QuestCategory.SkillBuilder,
    title: 'Crimping Practice',
    questlineId: 'climbing-catalyst',
    prerequisiteQuestId: 2103,
    description: 'Let\'s practice using the "crimp" grip that is essential for small holds.',
    details: 'With supervision, find a safe, strong edge, like the top of a door frame. Practice hanging for just a few seconds using a "crimp" grip (fingers bent at the middle knuckle). This is a powerful but advanced technique, so be careful!'
  }
];
